const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

async function parseResponse(response) {
  const text = await response.text();
  let body = {};

  if (text) {
    try {
      body = JSON.parse(text);
    } catch (error) {
      body = {};
    }
  }

  if (!response.ok) {
    throw new Error(body.error || `请求失败，状态码 ${response.status}`);
  }

  return body;
}

async function request(path, options = {}, { useJsonContentType = true } = {}) {
  const headers = {
    ...(useJsonContentType ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {})
  };

  Object.keys(headers).forEach((key) => {
    if (headers[key] == null) {
      delete headers[key];
    }
  });

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers
  });

  return parseResponse(response);
}

export async function apiRequest(path, options = {}) {
  return request(path, options);
}

export async function apiMultipartRequest(path, options = {}) {
  return request(path, options, { useJsonContentType: false });
}
